/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { CartOutlets, PromotionLocation } from '@spartacus/cart/base/root';
import { BaseSiteService } from '@spartacus/core';
import { OrderConfirmationItemsComponent } from '@spartacus/order/components';
import { Order, OrderFacade } from '@spartacus/order/root';
import { PromotionsComponent } from '@spartacus/storefront';
import { Observable, take } from 'rxjs';
import { UdxCartItemListComponent } from 'src/app/udxb2b/features/cart-shared';
import { storeFrontConfig } from 'src/app/udxb2b/shared/constant/storefront-config';
import { UdxCartItemListComponent as UdxCartItemListComponent_1 } from '../../../cart-shared/cart-item-list/cart-item-list.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'udx-cx-order-confirmation-items',
    templateUrl: './udx-order-confirmation-items.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PromotionsComponent, UdxCartItemListComponent_1, AsyncPipe]
})
export class UdxOrderConfirmationItemsComponent extends OrderConfirmationItemsComponent {
  baseSiteService = inject(BaseSiteService);

  override readonly cartOutlets = CartOutlets;
  override promotionLocation: PromotionLocation = PromotionLocation.Checkout;
  override order$: Observable<Order | undefined> = this.orderFacade.getOrderDetails();
  constructor(protected override orderFacade: OrderFacade) {
    super(orderFacade);
  }
  usj:boolean = false;
  uhu:boolean = false;
  ush:boolean = false;
  ngOnInit(): void {
    this.baseSiteService.getActive()
    .pipe(take(1))
    .subscribe((baseSite) => {
      switch (baseSite) {
        case 'b2bportal':
          this.usj = true;
          break;
        case 'b2bportal_lv':
            this.uhu = true;
            break; 
            case 'b2bportal_ush':
              this.ush = true;
              break;      
          default:
            this.uhu = true;
      }
     
    });
  }
}
